<template>
  <section class="prize-pool">
    <div class="section-head">
      <img src="@/assets/image/title_circle1.png" class="head-dot" alt="" />
      <h2 class="head-title">全网奖金池</h2>
      <img src="@/assets/image/title_circle2.png" class="head-dot" alt="" />
    </div>
    <div class="cards-wrap">
      <ul class="cards">
        <li v-for="item in displayItems" :key="item.id" class="card">
          <div class="card-top">
            <span class="pool-name">{{ item.label }}</span>
            <span class="pool-people">{{ item.people }}人</span>
          </div>
          <div class="card-amount">
            <span class="num">{{ item.amount }}</span>
            <span class="unit">BL</span>
          </div>
          <button
            type="button"
            class="fenpei"
            :disabled="!!allocatingId || loading"
            @click="onAllocate(item)"
          >
            {{ allocatingId === item.id ? "分配中…" : "分配" }}
          </button>
        </li>
      </ul>
    </div>
    <p v-if="loading" class="pool-tip">奖金池数据加载中…</p>
  </section>
</template>

<script>
import { Notify, Toast } from "vant";
import { PRIZE_POOL_LEVELS } from "../constants.js";
import {
  fetchLevelPrizePoolsFromChain,
  allocateLevelPrizePool,
} from "../helpers/prizePoolChain.js";

function skeletonRows() {
  return PRIZE_POOL_LEVELS.map(({ id, label }) => ({
    id,
    label,
    people: "—",
    amount: "—",
  }));
}

export default {
  name: "AdminPrizePoolSection",
  data() {
    return {
      rows: skeletonRows(),
      loading: false,
      allocatingId: null,
    };
  },
  computed: {
    displayItems() {
      return this.rows.length ? this.rows : skeletonRows();
    },
  },
  mounted() {
    this.refreshPools();
  },
  methods: {
    async refreshPools() {
      this.loading = true;
      try {
        const list = await fetchLevelPrizePoolsFromChain();
        this.rows = list;
      } catch (err) {
        const msg =
          typeof err?.message === "string"
            ? err.message
            : "奖金池数据读取失败";
        Notify({ type: "danger", message: msg });
        this.rows = skeletonRows();
      } finally {
        this.loading = false;
      }
    },
    async onAllocate(item) {
      if (this.allocatingId) return;

      const people = Number(item.people);
      if (!people || item.people === "—") {
        Toast("该级别暂无用户，无法分配");
        return;
      }
      if (item.amount === "—" || Number(item.amount) <= 0) {
        Toast("该级别池内暂无 BL，无法分配");
        return;
      }

      this.allocatingId = item.id;
      try {
        await allocateLevelPrizePool(item.id);
        Toast.success(`${item.label} 分配已上链`);
        await this.refreshPools();
      } catch (err) {
        Toast.fail(this.txErrMessage(err, "分配失败"));
      } finally {
        this.allocatingId = null;
      }
    },
    txErrMessage(err, fallback) {
      const m = err?.message || err?.msg;
      if (typeof m === "string" && m.trim()) return m;
      return fallback;
    },
  },
};
</script>

<style lang="scss" scoped>
.prize-pool {
  margin-bottom: 40px;
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 28px;
}

.head-dot {
  width: 5vw;
}

.head-title {
  margin: 0;
  font-size: 32px;
  font-weight: 600;
  color: #e6b141;
}

.cards-wrap {
  margin: 0 -32px;
  padding: 0 32px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.cards {
  display: flex;
  gap: 20px;
  list-style: none;
  margin: 0;
  padding: 0 0 8px;
  width: max-content;
}

.card {
  flex-shrink: 0;
  width: 200px;
  padding: 24px 20px;
  border-radius: 12px;
  background: #ffd398;
  border: 2px solid #f56c32;
  box-sizing: border-box;
  text-align: center;
}

.card-top {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.pool-name {
  font-size: 28px;
  font-weight: 600;
  color: #333;
}

.pool-people {
  font-size: 24px;
  color: #666;
}

.card-amount {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.num {
  font-size: 28px;
  font-weight: 600;
  color: #ff601d;
  font-variant-numeric: tabular-nums;
}

.unit {
  font-size: 26px;
  font-weight: 700;
  color: #ff601d;
}

.pool-tip {
  margin: 16px 0 0;
  font-size: 22px;
  color: #8c8c8c;
  text-align: center;
}
.fenpei {
  width: 100%;
  padding: 8px;
  border: none;
  color: #fff;
  background: #ff601d;
  border-radius: 8px;
  font-size: 22px;
  cursor: pointer;
  margin-top: 10px;
}

.fenpei:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
